<template>
  <div>
    <div class="row">
      <div class="col-md-6">

        <!-- Full name -->
        <div class="form-group">
          <label>Клиент</label>
          <p>{{ transaction.full_name }}</p>
        </div>

        <!-- Amount -->
        <div class="form-group">
          <label>Сумма</label>
          <p>{{ toMoney(transaction.amount) }}</p>
        </div>

        <!-- Transaction type -->
        <div class="form-group">
          <label>Тип операции</label>
          <p>{{ transaction.transaction_type }}</p>
        </div>

        <!-- Datetime -->
        <div class="form-group">
          <label>Дата и время</label>
          <p>{{ formatDate(transaction.datetime) }}</p>
        </div>

        <!-- Notation -->
        <div class="form-group">
          <label>Примечание</label>
          <p>{{ transaction.notation }}</p>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { getTransaction } from '@/services/transaction.service'
import helpers from '@/helpers'

export default {
  name: 'transaction-detail',
  props: {
    transactionId: {
      required: true,
      type: [String, Number]
    }
  },
  data () {
    return {
      transaction: {
        id: null,
        amount: '',
        transaction_type: '',
        datetime: '',
        notation: '',
        full_name: ''
      }
    }
  },
  mounted () {
    if (this.transactionId !== undefined) {
      this.transaction.id = this.transactionId

      getTransaction(this.transaction.id).then((response) => {
        this.transaction = response.data
      })
    }
  },
  methods: {
    formatDate: helpers.formatDate,
    toMoney: helpers.toMoney
  }
}
</script>


// WEBPACK FOOTER //
// TransactionDetail.vue?d7017c6c